module.exports = __webpack_public_path__ + "fonts/Lato-Black.f80bda6a.woff";